import React from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';

import { setStatus } from 'store/entities/submissions';
import { submissionStatuses } from 'utils/constants/submissionConstants';
import { isCustomOption } from 'components/UIComponents/Form/Select';

import { Control, Field, Label, Select } from 'components/UIComponents/Form';
import { Column } from 'components/UIComponents/Layout';

const StatusFilter = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { status, submissionsListLoading } = useSelector(
    state => state.submissions
  );

  const statusOptions = Object.keys(submissionStatuses).map(status => ({
    value: status,
    label: t(submissionStatuses[status].text),
    notClearable: submissionStatuses[status].notClearable,
  }));

  return (
    <Column
      tablet={{ size: 6 }}
      desktop={{ size: 6 }}
      widescreen={{ size: 5 }}
      fullhd={{ size: 3 }}
    >
      <Field>
        <Control>
          <Label htmlFor="statusSelect">
            {t('datagate.external.submissions.filter.status.label')}
          </Label>
          <Select
            isDisabled={submissionsListLoading}
            id="statusSelect"
            placeholder={t(
              'datagate.external.submissions.filter.status.placeholder'
            )}
            isClearable={status[0] !== statusOptions[0].value}
            isMulti
            options={statusOptions}
            value={status}
            onChange={value =>
              dispatch(
                setStatus(
                  value
                    ? value.map(opt => (isCustomOption(opt) ? opt : opt.value))
                    : []
                )
              )
            }
            getOptionLabel={option =>
              statusOptions.find(opt => opt.value === (option?.value ?? option))
                ?.label
            }
            getOptionValue={option =>
              statusOptions.find(opt => opt.value === (option?.value ?? option))
                ?.value
            }
            ariaLabel="Status select"
          />
        </Control>
      </Field>
    </Column>
  );
};

export default StatusFilter;
